"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roccamontepiano": {
    "08cbfaac": [{
      "hkey": "0e885c55",
      "slug": "francione-tracanna",
      "name": "Francione-Tracanna",
      "primary": true,
      "skipSearch": false
    }],
    "francione": [{
      "hkey": "0e885c55",
      "slug": "francione-tracanna",
      "name": "Francione-Tracanna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e88dd1ee": [{
      "hkey": "11271c30",
      "slug": "roccamontepiano",
      "name": "Roccamontepiano",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "11271c30",
      "slug": "roccamontepiano",
      "name": "Roccamontepiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a74d9864": [{
      "hkey": "11271c30",
      "slug": "roccamontepiano",
      "name": "Roccamontepiano",
      "primary": true,
      "skipSearch": false
    }],
    "sant-angelo": [{
      "hkey": "11271c30",
      "slug": "roccamontepiano",
      "name": "Roccamontepiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;